
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

export default {
name: 'ToolBar',
components: {
Tabbar,
TabbarItem
},
data () {
return {
isSelected: true,
platcode: ''
}
},
created: function () {
this.platcode = this.$UserUtils.getPlatCode()
}
}



// WEBPACK FOOTER //
// ./src/components/ToolBarBottom.vue